export class NipValidator {
    private static format = /^[0-9]{10}$/;
    private static weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];

    public static isValid(value: string | null | undefined): boolean {
        if (!value) return false;

        value = NipValidator.normalize(value);
        if (!NipValidator.format.test(value)) {
            return false;
        }

        let sum = 0;

        for (let i = 0; i < NipValidator.weights.length; ++i) {
            sum += Number(value[i]) * NipValidator.weights[i];
        }

        const checksum = (sum % 11);
        const nipChecksum = Number(value[value.length - 1]);

        return nipChecksum === checksum;
    }

    public static normalize(nip: string): string {
        return nip ? nip.replace(/[\s\-]+/g, '') : '';
    }
}
